import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currency'
})
export class CurrencyPipe implements PipeTransform {
  /**
   * @param value Monto a formatear
   * @param country Código de país/moneda: 'CO' (default), 'MX', 'BR'
   */
  transform(value: number, country: 'CO' | 'MX' | 'BR' = 'CO'): string {
    let locale = 'es-CO';
    let currency = 'COP';
    switch (country) {
      case 'MX':
        locale = 'es-MX';
        currency = 'MXN';
        break;
      case 'BR':
        locale = 'pt-BR';
        currency = 'BRL';
        break;
      case 'CO':
      default:
        locale = 'es-CO';
        currency = 'COP';
    }
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }
}
